import { VideoType } from "../types/types";

const PLAY_VIDEO = "video/PLAY_VIDEO";

export type InitialStateType = typeof initialState

let initialState = {
   isPlaying: true,
   url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Video/King%20of%20the%20Hill.mp4",
   title: "King of the Hill",
   video: [
      {
         title: "King of the Hill",
         url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Video/King%20of%20the%20Hill.mp4",
      },

   ] as Array<VideoType>,
};

const videoReducer = (state = initialState, action: any) => {
   switch (action.type) {
      case PLAY_VIDEO:
         return {
            ...state,
            isPlaying: !state.isPlaying,
         };
      default:
         return state;
   }
};

export const playVideoActionCreator = (currentVideo: VideoType) => ({
   type: PLAY_VIDEO,
   url: currentVideo.url,
   title: currentVideo.title,
});

export default videoReducer;
